<div class="container pt-3">
  <div class="row">
    <ng-container *ngFor="let question of question_list;let i = index;">
      <div class="col-md-12">
        <mat-form-field floatLabel="always" class="mat-border-none">
          <mat-label>
            {{question.label}}
          </mat-label>

          <input type="text" matInput style="display: none;">

          <mat-radio-group [(ngModel)]="feedback.questions[i].optionCode">
            <mat-radio-button *ngFor="let item of question.options" [value]="item.code">{{item.title}}
            </mat-radio-button>
          </mat-radio-group>
        </mat-form-field>
      </div>
    </ng-container>
    <div class="col-md-12">
      <mat-form-field floatLabel="always">
        <mat-label>
          Suggestions (if any)
        </mat-label>
        <input type="text" matInput [(ngModel)]="feedback.onboardingAppFeedback">
      </mat-form-field>
    </div>

    <div class="offset-8 col-md-4 align-self-center">
      <ng-container>
        <button style="min-width: 100px;" class="blob-btn float-right btn   mx-1 float-right tallite-action"
          type="submit" (click)="submitfeedBackDetails()">

          {{ 'PRE_OFFER.save' | translate }}
          <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
            </span>
          </span>
        </button>

        <button style="min-width: 100px;" class="float-right  blob-btn-cancel btn mx-1 mx-1 tallite-action"
          (click)="resetfeedBackDetails()">
          <!--  -->
          {{ 'PRE_OFFER.cancel' | translate }}
          <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
              <span class="blob-btn-cancel__blob"></span>
              <span class="blob-btn-cancel__blob"></span>
              <span class="blob-btn-cancel__blob"></span>
              <span class="blob-btn-cancel__blob"></span>
            </span>
          </span>
        </button>
      </ng-container>
    </div>

  </div>
</div>
